/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CouponAssignmentStatus = {
    _11184809: '11184809',
    ASSIGNED: 'ASSIGNED',
    REDEEMED: 'REDEEMED',
    unknown_default_open_api: '11184809'
} as const;
export type CouponAssignmentStatus = typeof CouponAssignmentStatus[keyof typeof CouponAssignmentStatus];


export function instanceOfCouponAssignmentStatus(value: any): boolean {
    for (const key in CouponAssignmentStatus) {
        if (Object.prototype.hasOwnProperty.call(CouponAssignmentStatus, key)) {
            if (CouponAssignmentStatus[key as keyof typeof CouponAssignmentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CouponAssignmentStatusFromJSON(json: any): CouponAssignmentStatus {
    return CouponAssignmentStatusFromJSONTyped(json, false);
}

export function CouponAssignmentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponAssignmentStatus {
    return json as CouponAssignmentStatus;
}

export function CouponAssignmentStatusToJSON(value?: CouponAssignmentStatus | null): any {
    return value as any;
}

